<template>
     <vs-dialog scroll overflow-hidden v-model="active">
        <template #header>
          <h3>
          </h3>
        </template>
        <div class="con-content">
          <vs-row class="mt-4">
                <!-- <vs-col>
                    <vs-table striped>
                        <template #thead>
                        <vs-tr>
                            <vs-th style="text-align: left">
                                Concepto
                            </vs-th>
                            <vs-th>
                                Monto
                            </vs-th>
                            <vs-th>
                                Cuenta
                            </vs-th>
                            <vs-th v-if="infoCuenta != ''"></vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr>
                            <vs-td>
                            {{ rows.concepto }}
                            </vs-td>
                            <vs-td>
                            {{ rows.monto | currency}}
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    v-model="cuenta"
                                    @input="getInfo(cuentaGuardada)"
                                >
                                    <vs-option
                                        v-for="opcion in cuentaGuardada"
                                        :key="opcion.id" 
                                        :label="opcion.cuenta" :value="opcion.id">
                                            {{opcion.cuenta}}
                                    </vs-option>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <p class="mb-0">Tarjetahabiente: <strong>{{infoCuenta.nombre}}</strong></p>
                                <p class="mb-0">Banco: <strong>{{infoCuenta.banco}}</strong></p>
                                <p class="mb-0">Tipo: <strong>{{infoCuenta.tipo}}</strong></p>
                                <p class="mb-0">Cuenta: <strong>{{infoCuenta.cuenta}}</strong></p>
                            </vs-td>
                        </vs-tr>
                        </template>
                    </vs-table>
                </vs-col> -->
                
                <h5>¿Esta seguro de eliminar la domicilización de este cargo?</h5>
          </vs-row>
        </div>
        <template #footer>
            <div class="d-flex">
                <vs-button
                    danger
                    @click="active = false"
                    style="width: 45%;"
                >
                    Cancelar
                </vs-button>
                <vs-button
                    success
                    class="ml-auto"
                    @click="getCancelar(rows)"
                    style="width: 45%;"
                >
                    Guardar
                </vs-button>
            </div>
        </template>
     </vs-dialog>
</template>

<script>
import domicializacion from '../../../../../api/requests/domicializacion.js'
export default {
    props:[
      'value',
      'rows',
      'personaId',
      'cicloEscolar',
      'institucion',
      'programa',
      'cuentaGuardada'
    ],
    data () {
        return {
            active: false,
            tarjetahabiente: '',
            banco: '',
            tipo: '',
            cuenta: '',
            bancoNombre: [
                {
                    'id': 1,
                    'nombre': 'Banamex'
                },
                {
                    'id': 2,
                    'nombre': 'Scotiabank'
                },
                {
                    'id': 3,
                    'nombre': 'BBVA'
                },
            ],
            tipoNombre: [
                {
                    'id': 1,
                    'nombre': 'T. Débito'
                },
                {
                    'id': 2,
                    'nombre': 'CLABE'
                },
                {
                    'id': 3,
                    'nombre': 'Cuenta de cheques BANAMEX'
                },
            ],
            infoCuenta: {}
        }
    },
    methods: {
        async getCancelar(info){
            try {
                const response = await domicializacion.getCancelar(info.id)
                this.$emit('refreshTable')
                this.active = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    title: 'Operación éxitosa'
                })
                this.cuentaGuardada = response.data.cuentas_bancarias
            } catch (error) {
                this.active = false
            }

        },
        getInfo(info){
            info.forEach(i => {
                if(this.cuenta === i.id){
                    this.infoCuenta = {
                        "nombre": i.tarjetahabiente,
                        "cuenta": i.cuenta,
                        "banco": i.banco,
                        "tipo": i.tipo,
                        "id": i.id
                    }
                }
            })
        },
        async getGuardarSeleccionada(){
            const loading = this.$vs.loading()
            try {
                let formData = new FormData();
                formData.append("id", this.personaId),
                formData.append("ciclo_escolar", this.cicloEscolar),
                formData.append("cuenta", this.infoCuenta.id),
                formData.append("institucion", this.institucion),
                formData.append("programa", this.programa),
                formData.append("cargo", this.rows.id)
                
                const response = await domicializacion.getGuardarSeleccionada(formData)
                console.log(response)
                var xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v1/domiciliacion/solicitud/descargar/${response.data.data}`, true);
                xhr.responseType = 'blob';

                xhr.onload = function(e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], {type: 'application/pdf'});
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = "Solicitud-Domiciliacion.pdf";
                    link.click();       
                }
                };

                xhr.send();
                this.active = false
                loading.close()
                
            } catch (error) {
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    title: 'Algo salio mal',
                    text: 'Por favor contacta al administrador'
                })
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}

.dividerLine {
  width: 100%;
  border-bottom: 1px solid #ddd
}

.greyColor {
  color: gray
}

.greyOscuro {
  color: rgb(78, 78, 78);
  font-weight: bold;
}

.vs-select__option.activeOption {
    background: rgba(var(--vs-color), 0.05);
    color: rgba(var(--vs-color), 1);
    pointer-events: all;
}

</style>

<style>


.domicializar .vs-dialog{
    max-width: 95% !important;
}
</style>